/**
 * @generated SignedSource<<bbc123c3686e3650592fae2a53a287d9>>
 * @relayHash 893e4cc7292e06a05c8e163bfde7c2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000

import type { ConcreteRequest } from 'relay-runtime';
export type PageStarActionButtonPageStarMutation$variables = {
  id: string;
};
export type PageStarActionButtonPageStarMutation$data = {
  readonly favouritePage: {
    readonly content: {
      readonly id: string | null | undefined;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly favouritedDate: string | null | undefined;
            readonly isFavourite: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      };
    };
  } | null | undefined;
};
export type PageStarActionButtonPageStarMutation = {
  response: PageStarActionButtonPageStarMutation$data;
  variables: PageStarActionButtonPageStarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "favouritePageInput"
      }
    ],
    "concreteType": "FavouritePagePayload",
    "kind": "LinkedField",
    "name": "favouritePage",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "FavouritedSummary",
                    "kind": "LinkedField",
                    "name": "favourited",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "favouritedDate"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageStarActionButtonPageStarMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageStarActionButtonPageStarMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "893e4cc7292e06a05c8e163bfde7c2d8",
    "id": "e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000",
    "metadata": {},
    "name": "PageStarActionButtonPageStarMutation",
    "operationKind": "mutation",
    "text": "mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
  }
};
})();

(node as any).hash = "2fe8e2e773241c74a33b1336ab2db2b2";

export default node;
